import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Dashboard from './pages/Dashboard';
import LessonPage from './pages/LessonPage';
import Summary from './pages/Summary';
import { StorageService } from './services/StorageService';

function App() {
  const [activeTab, setActiveTab] = useState('Dashboard');
  const [lessonProgress, setLessonProgress] = useState({});

  useEffect(() => {
    const progress = StorageService.getLessonProgress();
    setLessonProgress(progress);
  }, []);

  const updateLessonProgress = (lessonNumber, completed) => {
    const newProgress = { ...lessonProgress, [lessonNumber]: completed };
    setLessonProgress(newProgress);
    StorageService.saveLessonProgress(newProgress);
  };

  return (
    <Router>
      <div className="min-h-screen bg-cream">
        <div className="max-w-7xl mx-auto">
          <Navigation activeTab={activeTab} setActiveTab={setActiveTab} />
          <AnimatePresence mode="wait">
            <motion.main 
              key={activeTab} 
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }} 
              exit={{ opacity: 0, y: -20 }} 
              transition={{ duration: 0.3 }} 
              className="px-6 pb-12"
            >
              <Routes>
                <Route 
                  path="/" 
                  element={<Dashboard lessonProgress={lessonProgress} updateLessonProgress={updateLessonProgress} />} 
                />
                <Route 
                  path="/lesson/:lessonNumber" 
                  element={<LessonPage lessonProgress={lessonProgress} updateLessonProgress={updateLessonProgress} />} 
                />
                <Route path="/summary" element={<Summary />} />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </motion.main>
          </AnimatePresence>
        </div>
      </div>
    </Router>
  );
}

export default App;